<template>
  <div class="server-error-view">
    <div class="stage">
      <svg class="illustration" viewBox="0 0 1378 823" aria-hidden="true">
        <path class="blob" d="M1336 420C1335 448 1332 496 1320 531C1308 566 1287 600 1262 628C1237 656 1202 679 1170 697C1138 715 1100 727 1067 736C1034 745 1000 750 970 753C940 756 911 756 884 755C857 754 832 750 808 744C784 738 763 734 743 722C723 710 705 687 690 670C675 653 666 633 655 620C644 607 638 598 627 593C616 588 613 576 592 589C571 602 539 641 500 668C461 695 402 741 357 753C312 765 270 752 231 741C192 730 149 711 120 686C91 661 71 624 58 589C45 554 40 514 40 477C40 440 45 400 55 364C65 328 79 292 99 262C119 232 143 200 177 181C211 162 249 142 301 148C353 154 446 206 487 217C528 228 529 217 545 213C561 209 572 201 584 192C596 183 607 170 620 157C633 144 648 128 664 117C680 106 699 97 719 90C739 83 760 77 783 73C806 69 830 67 855 67C880 67 906 69 933 73C960 77 989 83 1018 92C1047 101 1078 112 1108 127C1138 142 1169 161 1197 184C1225 207 1252 233 1274 263C1296 293 1316 338 1326 364C1336 390 1337 392 1336 420Z"/>
        <g class="plugs">
          <!-- The cables run past the edges of the drawing to the edges of the screen. -->
          <path class="cable" d="M228 388H165A70 70 0 0 0 95 458V465A75 75 0 0 1 20 540H-4000"/>
          <path class="body" d="M282 344H269A44 44 0 0 0 269 432H282Z"/>
          <rect class="light" x="251.5" y="354" width="5" height="67" rx="2.5"/>
          <rect class="light" x="260" y="354" width="5" height="67" rx="2.5"/>
          <rect class="light" x="269" y="354" width="5" height="67" rx="2.5"/>
          <rect class="body" x="298" y="361" width="31" height="12" rx="6"/>
          <rect class="shade" x="298" y="368" width="31" height="5" rx="2.5"/>
          <rect class="body" x="298" y="400" width="31" height="12" rx="6"/>
          <rect class="shade" x="298" y="407" width="31" height="5" rx="2.5"/>
          <rect class="light" x="280" y="341" width="23" height="93" rx="4"/>

          <path class="cable" d="M1168 372H1230A67 67 0 0 1 1297 439V455A67 67 0 0 0 1364 522H5400"/>
          <path class="body" d="M1114 331H1129A42 42 0 0 1 1129 415H1114Z"/>
          <rect class="light" x="1121" y="340" width="5" height="66" rx="2.5"/>
          <rect class="light" x="1129.5" y="340" width="5" height="66" rx="2.5"/>
          <rect class="light" x="1138.5" y="340" width="5" height="66" rx="2.5"/>
          <rect class="light" x="1086" y="328" width="30" height="90" rx="4"/>
          <rect class="face" x="1086" y="328" width="22" height="90" rx="4"/>
          <ellipse class="hole" cx="1097.5" cy="352.5" rx="4" ry="6.5"/>
          <ellipse class="hole" cx="1097.5" cy="391" rx="4" ry="6.5"/>

          <path class="sparkle" d="M305 284.5L308.5 288L305 291.5L301.5 288Z"/>
          <path class="sparkle" d="M266.5 312.5L270 316L266.5 319.5L263 316Z"/>
          <path class="sparkle" d="M255 451L258.5 454.5L255 458L251.5 454.5Z"/>
          <path class="sparkle" d="M324 477L327.5 480.5L324 484L320.5 480.5Z"/>
          <path class="sparkle" d="M282.5 492.5L286 496L282.5 499.5L279 496Z"/>
          <path class="sparkle" d="M1105 294.5L1108.5 298L1105 301.5L1101.5 298Z"/>
          <path class="sparkle" d="M1049 319L1052.5 322.5L1049 326L1045.5 322.5Z"/>
          <path class="sparkle" d="M1072.5 448L1076 451.5L1072.5 455L1069 451.5Z"/>
          <path class="sparkle" d="M1141 443.5L1144.5 447L1141 450.5L1137.5 447Z"/>
        </g>
      </svg>
      <h1 class="code">500</h1>
      <p class="message">Something wrong just happened</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// The page is drawn on a 1378 × 823 stage, scaled to fit the screen.
.server-error-view {
  --scale: min(100vw / 1378, 100vh / 823);
  position: relative;
  height: 100%;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background: #24244D;

  .stage {
    position: absolute;
    left: 50%;
    top: 50%;
    width: calc(1378 * var(--scale));
    height: calc(823 * var(--scale));
    transform: translate(-50%, -50%);
  }

  .illustration {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    overflow: visible;

    .blob {
      fill: #29296B;
    }

    .cable {
      fill: none;
      stroke: #FFFFFF;
      stroke-width: 10;
    }

    .body {
      fill: #9AA5CC;
    }

    .shade {
      fill: #8792C2;
    }

    .light {
      fill: #FFFFFF;
    }

    .face {
      fill: #B1BEE0;
    }

    .hole {
      fill: #2B2C5C;
    }

    .sparkle {
      fill: #7BD9F8;
    }
  }

  .code,
  .message {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0;
    padding: 0 16px;
    transform: translateY(-50%);
    line-height: 1;
    text-align: center;
  }

  .code {
    top: calc(344 * var(--scale));
    color: transparent;
    font-size: max(64px, calc(243 * var(--scale)));
    font-weight: 700;
    // The spacing also follows the last digit: indenting by as much keeps the number centred.
    letter-spacing: 0.08em;
    text-indent: 0.08em;
    -webkit-text-stroke: max(2px, calc(3 * var(--scale))) #FFFFFF;
  }

  .message {
    top: calc(490 * var(--scale));
    color: #FFFFFF;
    font-size: max(16px, calc(35 * var(--scale)));
    font-weight: 600;
  }

  // On a narrow screen the plugs would run into the text.
  @media (max-width: 640px) {
    .plugs {
      display: none;
    }
  }
}
</style>
